<template>
  <ul class="orderInfo">
    <li>
      <div class="th">{{ roomList.infoType!=3?'预订时间':'预定时间' }}</div>
      <div class="td">{{ roomList.createTime ? roomList.createTime.substring(0,16) : '--' }}</div>
    </li>
    <li>
      <div class="th">使用时长</div>
      <div class="td">{{ roomList.dateTime || '--' }}</div>
    </li>
    <li>
      <div class="th">使用时间</div>
      <div class="td">{{ roomList.beginTime || '--' }}</div>
    </li>
    <li>
      <div class="th">离店时间</div>
      <div class="td">{{ roomList.endTime || '--' }}</div>
    </li>
    <li>
      <div class="th">状态</div>
      <!-- "订单状态（1 锁定 2 预订 3 入住 5 已退房 6 过期 7 超时 8 取消） -->
      <div v-if="roomList.infoType===5" class="td">
        {{ getRoomType==1?'已退房':'已退位' }}
      </div>
      <div v-else class="td" :class="roomList.infoType===3?'color-red':'color-ash'">
        {{ roomList.infoType===2?'已预订':roomList.infoType===3?'使用中':roomList.infoType===6?'已过期':roomList.infoType===7?'已超时':roomList.infoType===8?'已取消':'' }}
      </div>
    </li>
    <li class="liS">
      <div class="th thS">备注</div>
      <div class="td">{{ roomList.remarks || '--' }}</div>
    </li>
  </ul>
</template>

<script>

export default {
  props: {
    orderDeatilsData: {
      type: Object,
      default: () => { }
    },
    roomList: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {
      getRoomType: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位(5.10)
    };
  },
  activated() {},
  methods: {}
};
</script>
<style lang="less" scoped>
.color-red{
  color:#FF4949
}
.color-ash{
  color:#999999
}
</style>
